import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 38,
	height: 25,
	viewBox: "0 0 38 25",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.96094 10.9279C1.08891 10.9279 0.38199 11.6348 0.38199 12.5068C0.38199 13.3789 1.08891 14.0858 1.96094 14.0858V10.9279ZM36.9635 13.6233C37.5801 13.0067 37.5801 12.007 36.9635 11.3904L26.9152 1.34199C26.2985 0.725374 25.2988 0.725374 24.6822 1.34199C24.0656 1.95861 24.0656 2.95834 24.6822 3.57496L33.6141 12.5068L24.6822 21.4387C24.0656 22.0553 24.0656 23.0551 24.6822 23.6717C25.2988 24.2883 26.2985 24.2883 26.9152 23.6717L36.9635 13.6233ZM1.96094 14.0858H35.847V10.9279H1.96094V14.0858Z",
		fill: "white"
	})
});
const ForwardRef = forwardRef(SvgArrowRight);
export default ForwardRef;
